import { WL, WL_SUCCESS } from './WebLoggerService.jsx'
import { store } from '../main/Store.jsx'
import { ACT_GOTRECENTPROJECTS} from './actions.js'

export function refreshRecentProjects(token) {
	console.log("Refreshing recent projects")

    WL.GetProjects(token, "user", refreshRecentProjectsResult)
}

function refreshRecentProjectsResult(result, data) {

	if (result === WL_SUCCESS) {
		console.log("Dispatching new recent projects")
		store.dispatch({ type: ACT_GOTRECENTPROJECTS, recentProjects:data})
		
		
	}
}